import { useEffect, useRef } from 'react';

/*
 * Soft-light canvas background.
 * Matches exactly trlr_final_v2(1).html
 */

const ORBS = [
  { x: 0.20, y: 0.30, r: 0.55, sx: 0.05,  sy: 0.035, p: 0,   c: [195, 185, 215] },
  { x: 0.80, y: 0.50, r: 0.50, sx: 0.035, sy: 0.045, p: 2.1, c: [175, 195, 225] },
  { x: 0.50, y: 0.75, r: 0.45, sx: 0.06,  sy: 0.03,  p: 4.0, c: [205, 190, 175] },
  { x: 0.35, y: 0.85, r: 0.40, sx: 0.04,  sy: 0.055, p: 1.2, c: [185, 205, 195] },
  { x: 0.75, y: 0.20, r: 0.42, sx: 0.03,  sy: 0.04,  p: 3.3, c: [215, 198, 185] },
];

export default function Background() {
  const canvasRef = useRef(null);
  const rafRef    = useRef(null);
  const tRef      = useRef(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const cv = canvasRef.current;
    const ctx = cv.getContext('2d');
    let W, H;

    function resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth;
      H = window.innerHeight;
      cv.width  = W * dpr;
      cv.height = H * dpr;
      cv.style.width  = W + 'px';
      cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    resize();
    window.addEventListener('resize', resize);

    function draw() {
      tRef.current += 0.0015;
      const T = tRef.current;

      ctx.clearRect(0, 0, W, H);

      for (const o of ORBS) {
        const px  = W * (o.x + Math.sin(T * o.sx + o.p) * 0.2);
        const py  = H * (o.y + Math.cos(T * o.sy + o.p) * 0.15);
        const rad = Math.max(W, H) * o.r;
        const pulse = 0.7 + Math.sin(T * 0.35 + o.p) * 0.3;

        const g = ctx.createRadialGradient(px, py, 0, px, py, rad);
        g.addColorStop(0,    `rgba(${o.c[0]},${o.c[1]},${o.c[2]},${(0.3 * pulse).toFixed(3)})`);
        g.addColorStop(0.5,  `rgba(${o.c[0]},${o.c[1]},${o.c[2]},${(0.1 * pulse).toFixed(3)})`);
        g.addColorStop(1,    'rgba(0,0,0,0)');

        ctx.fillStyle = g;
        ctx.fillRect(0, 0, W, H);
      }

      rafRef.current = requestAnimationFrame(draw);
    }

    rafRef.current = requestAnimationFrame(draw);

    return () => {
      window.removeEventListener('resize', resize);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      style={{
        position:      'fixed',
        top:           0,
        left:          0,
        width:         '100vw',
        height:        '100vh',
        zIndex:        0,
        opacity:       0.4,
        mixBlendMode:  'multiply',
        pointerEvents: 'none',
      }}
    />
  );
}
